<template>
  <div class="detail-wrap">
    <a-spin :spinning="loading">
      <div class="content-container">

        <!-- 标题区域 -->
        <div class="title-section">
          <div class="title-left">
            <h1 class="main-title">{{ model.name || '科技成果名称' }}</h1>
            <div class="timestamp">{{ formatTime(model.createTime) }}</div>
          </div>
          <div class="title-right">
            <a-button type="primary" class="action-btn" @click="handleSeekCooperation">
              寻求合作
            </a-button>
            <a-button :type="followStatus === 1 ? 'default' : 'primary'" class="action-btn" @click="handleFollow">
              {{ followStatus === 1 ? '取消关注' : '关注' }}
            </a-button>
          </div>
        </div>

        <!-- 图片和信息区域 -->
        <div class="image-info-section">
          <div class="image-container">
            <img
              v-if="model.imageUrl"
              :src="getFileAccessHttpUrl(model.imageUrl)"
              :preview="true"
              style="width: 100%; max-height: 300px; object-fit: cover;"
            />
            <div v-else class="no-image">暂无图片</div>
          </div>
          <div class="info-container">
            <div class="info-left">
              <div class="info-item">
                <span class="info-label">技术领域：</span>
                <span class="info-value">{{ model.technicalField_dictText || '暂无' }}<span v-if="model.technicalField_dictText=='其他'">({{ model.technicalFieldCustom}})</span></span>
                
              </div>
              <div class="info-item">
                <span class="info-label">技术成熟度：</span>
                <span class="info-value">{{ model.technicalMaturity || '暂无' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">交易价格：</span>
                <span class="info-value">{{ model.price ? '￥' + model.price : '面议' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">联系人电话：</span>
                <span class="info-value">{{ maskPhone(model.contactPhone) || '暂无' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">单位简介：</span>
                <span class="info-value">{{ model.unitProfile || '暂无' }}</span>
              </div>
            </div>
            <div class="info-right">
              <div class="info-item">
                <span class="info-label">所在地区：</span>
                <span class="info-value">{{ getAreaText(model.areaId) || '暂无' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">合作方式：</span>
                <span class="info-value">{{ model.cooperateWay || '暂无' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">联系人：</span>
                <span class="info-value">{{ model.contactName || '暂无' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">所属单位名称：</span>
                <span class="info-value">{{ model.projectUnit || '暂无' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 成果详情 -->
        <div class="detail-section">
          <h2 class="section-title">成果详情</h2>
          <div class="section-content" v-html="model.detail"></div>
        </div>

        <!-- 知识产权情况 -->
        <div class="detail-section" v-if="model.knowledgeinfo">
          <h2 class="section-title">知识产权情况</h2>
          <div class="section-content" v-html="model.knowledgeinfo"></div>
        </div>

        <!-- 其他可选字段 -->
        <div class="detail-section" v-if="model.applications">
          <h2 class="section-title">应用效果及市场前景</h2>
          <div class="section-content" v-html="model.applications"></div>
        </div>

        <div class="detail-section" v-if="model.coreTechnologies">
          <h2 class="section-title">技术优势</h2>
          <div class="section-content" v-html="model.coreTechnologies"></div>
        </div>

        <div class="detail-section" v-if="model.remark">
          <h2 class="section-title">备注</h2>
          <div class="section-content" v-html="model.remark"></div>
        </div>
      </div>
    </a-spin>
    
    <!-- 寻求合作弹窗 -->
    <a-modal
      v-model="isCooperationModalVisible"
      title="寻求合作"
      :width="600"
      @ok="handleCooperationSubmit"
      @cancel="handleCooperationCancel"
    >
      <a-form layout="vertical" :form="cooperationForm">
        <a-form-item label="对接人发起姓名">
          <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入对接人姓名' }] }]" placeholder="请输入对接人发起姓名"></a-input>
        </a-form-item>
        
        <a-form-item label="单位名称">
          <a-input v-decorator="['unit', { rules: [{ required: true, message: '请输入单位名称' }] }]" placeholder="请输入您的单位名称"></a-input>
        </a-form-item>
        
        <a-form-item label="联系电话">
          <a-input v-decorator="['phone', { rules: [{ required: true, message: '请输入联系电话' }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }] }]" placeholder="请输入您的联系电话"></a-input>
        </a-form-item>
        
        <a-form-item label="邮箱">
          <a-input v-decorator="['email', { rules: [{ required: true, message: '请输入邮箱' }, { type: 'email', message: '请输入正确的邮箱格式' }] }]" placeholder="请输入您的邮箱"></a-input>
        </a-form-item>
        
        <a-form-item label="所在地区">
          <j-area-linkage
              type="cascader"
              v-decorator="['areaId', { rules: [{ required: true, message: '请选择所在地区' }] }]"
              placeholder="请选择所在地区"/>
        </a-form-item>
        
        <a-form-item label="预约时间">
          <a-date-picker v-decorator="['appointmentTime', { rules: [{ required: true, message: '请选择预约时间' }] }]" show-time style="width: 100%" valueFormat="YYYY-MM-DD HH:mm:ss"></a-date-picker>
        </a-form-item>
        
        <a-form-item label="预约事项说明">
          <a-textarea v-decorator="['appointmentRemark', { rules: [{ required: true, message: '请输入预约事项说明' }] }]" rows="4" placeholder="预约事项说明"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getAction,httpAction } from "@/api/manage";
import { getFileAccessHttpUrl } from '@api/manage'
import JAreaLinkage from "@comp/jeecg/JAreaLinkage";
import Area from '@/components/_util/Area'

export default {
  name: "AchievementDetail",
  components: {
    JAreaLinkage
    
  },
  data() {
    return {
      model: {},
      loading: false,
      pcaData: null,
      url: {
        getById: "/xjtech/techAchievement/queryById",
        save: "/xjtech/techInteraction/add",
        checkFollow: "/xjtech/techInteraction/checkFollow",
        cancelFollow: "/xjtech/techInteraction/cancelFollow"
      },
      // 寻求合作弹窗相关数据
      isCooperationModalVisible: false,
      cooperationForm: this.$form.createForm(this),
      // 关注状态，1已关注，0未关注
      followStatus: 0
    };
  },
  computed: {
    tagArray() {
      if (this.model.tag) {
        return this.model.tag.split(",");
      }
      return [];
    }
  },
  mounted() {
    this.pcaData = new Area()
    this.loadData();
  },
  methods: {
    getFileAccessHttpUrl,
    loadData() {
      const id = this.$route.query.id;
      if (!id) {
        this.$message.warning("参数错误");
        this.$router.go(-1);
        return;
      }

      this.loading = true;
      getAction(this.url.getById, { id: id })
        .then(res => {
          if (res.success) {
            this.model = res.result;
            // 获取成果详情后，检查关注状态
            this.checkFollowStatus();
          } else {
            this.$message.warning(res.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 检查关注状态
    checkFollowStatus() {
      if (!this.model.id) return;
      getAction(this.url.checkFollow, { techId: this.model.id })
        .then(res => {
          if (res.success) {
            this.followStatus = res.result;
          } else {
            console.warn('检查关注状态失败:', res.message);
          }
        })
        .catch(err => {
          console.error('检查关注状态出错:', err);
        });
    },
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    maskPhone(phone) {
      if (!phone) return '';
      if (phone.length === 11) {
        return phone.substring(0, 3) + '****' + phone.substring(7);
      }
      return phone;
    },
    handleSeekCooperation() {
      this.isCooperationModalVisible = true;
    },
    handleFollow() {
      if (this.followStatus === 1) {
        // 取消关注
        getAction(this.url.cancelFollow, { techId: this.model.id,type: 0 })
          .then((res) => {
            if (res.success) {
              this.$message.success("取消关注成功");
              // 更新关注状态
              this.followStatus = 0;
            } else {
              this.$message.warning(res.message);
            }
          });
      } else {
        // 关注
        const data = {
          techId: this.model.id,
          type: 0
        }
        httpAction(this.url.save, data, 'post')
          .then((res) => {
            if (res.success) {
              this.$message.success("关注成功");
              // 更新关注状态
              this.followStatus = 1;
            } else {
              this.$message.warning(res.message);
            }
          });
      }
    },
    getAreaText(code) {
      if (!code || !this.pcaData) {
        return ''
      }
      // 优先使用字典文本，如果没有则通过 Area.js 获取
      if (this.model.areaId_dictText) {
        return this.model.areaId_dictText
      }
      return this.pcaData.getText(code) || ''
    },
    handleCooperationSubmit() {
      this.cooperationForm.validateFields((err, values) => {
        if (!err) {
          // 这里可以添加表单提交的API调用逻辑
          console.log('表单提交数据:', values);
          const data = {
            ...values,
            type: 1,
            techId: this.model.id,
          }
          httpAction(this.url.save, data, 'post')
            .then((res) => {
              if (res.success) {
                this.$message.success("提交成功");
              } else {
                this.$message.warning(res.message);
              }
            })
            .finally(() => {
              this.isCooperationModalVisible = false;
              this.cooperationForm.resetFields();
            });
        }
      });
    },
    handleCooperationCancel() {
      this.isCooperationModalVisible = false;
      this.cooperationForm.resetFields();
    },
  }
};
</script>

<style scoped lang="less">
.detail-wrap {
  padding: 20px;
  background-color: #fff;
  min-height: 100vh;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
  background-color: #fff;
}

.service-platform {
  font-size: 12px;
  color: #666;
  margin-bottom: 10px;
}

.title-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
}

.title-left {
  flex: 1;
}

.main-title {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  margin: 0 0 10px 0;
  line-height: 1.4;
}

.timestamp {
  font-size: 14px;
  color: #666;
}

.title-right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 20px;
}

.action-btn {
  min-width: 100px;
  height: 36px;
}

.image-info-section {
  display: flex;
  gap: 30px;
  margin-bottom: 40px;
}

.image-container {
  flex-shrink: 0;
  width: 200px;
  
  /deep/ .ant-image {
    width: 100%;
    height: auto;
    
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
      border-radius: 4px;
    }
  }
  
  .no-image {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    color: #999;
    border-radius: 4px;
  }
}

.info-container {
  flex: 1;
  display: flex;
  gap: 40px;
}

.info-left,
.info-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  line-height: 1.6;
}

.info-label {
  font-weight: normal;
  color: #333;
  min-width: 100px;
  flex-shrink: 0;
}

.info-value {
  color: #333;
  flex: 1;
  word-break: break-all;
}

.detail-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
}

.section-content {
  font-size: 14px;
  color: #333;
  line-height: 1.8;
  word-break: break-all;
  
  /deep/ p {
    margin-bottom: 10px;
  }
}

@media (max-width: 768px) {
  .title-section {
    flex-direction: column;
  }
  
  .title-right {
    margin-left: 0;
    margin-top: 15px;
    flex-direction: row;
  }
  
  .image-info-section {
    flex-direction: column;
  }
  
  .image-container {
    width: 100%;
  }
  
  .info-container {
    flex-direction: column;
    gap: 20px;
  }
}
</style>